import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type UpdateDefaultProcessStepRequestDto = ClientInferRequest<
  typeof contract.defaultProcessSteps.update
>["body"];

export type UpdateDefaultProcessStepResponseDto = ClientInferResponseBody<
  typeof contract.defaultProcessSteps.update
>;

export const updateDefaultProcessStep = async ({
  id,
  payload,
}: {
  id: string;
  payload: UpdateDefaultProcessStepRequestDto;
}): Promise<UpdateDefaultProcessStepResponseDto | null> => {
  const response = await api.defaultProcessSteps.update.mutation({
    params: { id },
    body: {
      ...payload,
    },
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to update default process step", response.status, response.body);
};
